import { Controller } from "@hotwired/stimulus"

// Il passo 4 «Conferma i dati» della scheda di verifica (pages/VerificaBandi.js): quello che React ricalcolava a ogni
// modifica dei dati.
// - Il suggerimento «dati-aiuto-hint»: con importo massimo del progetto e copertura positivi e l'aiuto massimo
//   (arrotondato) diverso da progetto × copertura / 100; «Usa» scrive quella cifra arrotondata nell'aiuto massimo.
// - Le due caselle dei modi di calcolo (somme forfettarie, interessi di un piano) si escludono.
// - Una parte del passo che il server aveva a null (data-dati-sezione con il suo campo data-dati-presente disattivato)
//   si invia solo dopo che la si tocca, come l'oggetto che React creava alla prima modifica.
// - Il pannello di conferma (bando verificato): «Conferma i dati» lo apre con il riepilogo dei valori della pagina al
//   posto dell'invio; «Annulla» lo chiude; un salvataggio riuscito lo chiude. Come lo stato di React, resta aperto
//   quando la scheda è riletta con morph (o il salvataggio non riesce).
// Task 55: il conteggio di limiti, condizioni e requisiti del riepilogo conta le righe data-dati-riga dentro
// data-dati-elenco="regole|condizioni|requisiti"; senza quel contenitore resta il numero salvato.
export default class extends Controller {
  static targets = ["copertura", "progettoMax", "tetto", "hint", "hintTesto", "usa", "forfettario", "interessi",
    "pannello", "conferma", "riepilogoCopertura", "conteggio", "riepilogoMaggiorazione", "riepilogoBase",
    "baseCategoria", "basePunto"]
  static values = { verificato: Boolean, categorie: Object }

  connect() {
    this.aperto = false
    this.aggiornaSuggerimento()
  }

  tocca(event) {
    const sezione = event.target.closest?.("[data-dati-sezione]")
    sezione?.querySelector("[data-dati-presente]")?.removeAttribute("disabled")
    this.aggiornaSuggerimento()
    if (this.aperto) this.riepilogo()
  }

  calcolo() {
    const p = Number(this.progettoMaxTarget.value)
    const c = Number(this.coperturaTarget.value)
    if (!(p > 0 && c > 0)) return null
    const calc = p * c / 100
    return Math.round(Number(this.tettoTarget.value)) !== Math.round(calc) ? calc : null
  }

  aggiornaSuggerimento() {
    if (!this.hasHintTarget) return
    const calc = this.calcolo()
    this.hintTarget.hidden = calc === null
    if (calc === null) return
    const eur0 = (n) => `${Math.round(n).toLocaleString("it-IT")} €`
    this.hintTestoTarget.textContent = `${this.coperturaTarget.value}% di ${eur0(Number(this.progettoMaxTarget.value))} = ${eur0(calc)}. Lo scenario usa l'aiuto massimo come tetto del contributo, e mai più di questa cifra.`
    this.usaTarget.textContent = `Usa ${eur0(calc)}`
  }

  usa() {
    const calc = this.calcolo()
    if (calc === null) return
    this.tettoTarget.value = String(Math.round(calc))
    this.tettoTarget.dispatchEvent(new Event("input", { bubbles: true }))
  }

  esclusivi(event) {
    if (!event.target.checked) return
    const altra = event.target === this.forfettarioTarget ? this.interessiTarget : this.forfettarioTarget
    altra.checked = false
  }

  conferma(event) {
    if (!this.verificatoValue) return
    event.preventDefault()
    this.aperto = true
    this.applica()
  }

  annulla() {
    this.aperto = false
    this.applica()
  }

  inviato(event) {
    if (event.target === this.element && event.detail.success) this.annulla()
  }

  // turbo:morph-element: dopo tutto il contenuto arriva quello del form
  riletto(event) {
    if (event.target !== this.element) return
    this.aggiornaSuggerimento()
    this.applica()
  }

  applica() {
    if (this.hasConfermaTarget) this.confermaTarget.hidden = this.aperto
    if (!this.hasPannelloTarget) return
    if (this.aperto) this.riepilogo()
    this.pannelloTarget.hidden = !this.aperto
  }

  riepilogo() {
    if (this.hasRiepilogoCoperturaTarget) {
      // dati.coverage_percent || "non indicata": lo 0 caricato (numero) è falso, uno 0 scritto (testo) no
      const c = this.coperturaTarget
      const caricatoZero = c.value === c.defaultValue && c.value !== "" && Number(c.value) === 0
      this.riepilogoCoperturaTarget.textContent = c.value === "" || caricatoZero ? "non indicata" : c.value
    }
    this.conteggioTargets.forEach((el) => {
      const elenco = this.element.querySelector(`[data-dati-elenco="${el.dataset.elenco}"]`)
      if (elenco) el.textContent = String(elenco.querySelectorAll("[data-dati-riga]").length)
    })
    if (this.hasRiepilogoMaggiorazioneTarget) {
      const sezione = this.element.querySelector("[data-controller~='maggiorazione-copertura']")
      const presente = sezione && !sezione.querySelector("[data-dati-presente]").disabled
      this.riepilogoMaggiorazioneTarget.hidden = !presente
      if (presente) {
        const attiva = sezione.querySelector("[data-maggiorazione-copertura-target='attiva']").checked
        const pct = sezione.querySelector("[data-chiave='percentuale']").value
        this.riepilogoMaggiorazioneTarget.querySelector("[data-testo]").textContent =
          attiva ? `${pct === "" ? "null" : Number(pct)}% secondo i criteri e la fonte compilati` : "disattivata"
      }
    }
    if (this.hasRiepilogoBaseTarget) {
      const nomi = this.baseCategoriaTargets.filter((c) => c.checked).map((c) => this.categorieValue[c.value] || c.value)
      this.riepilogoBaseTarget.querySelector("[data-categorie]").textContent = nomi.join(", ") || "nessuna categoria selezionata"
      this.riepilogoBaseTarget.querySelector("[data-punto]").textContent = (this.hasBasePuntoTarget && this.basePuntoTarget.value) || "non indicato"
    }
  }
}
